// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module './Au... Remove this comment to see the full error message
import auth from './Auth';

const hasPortalId = () => !!window.location.href.match(/^https?:\/\/(?:app|local).hubspot(?:qa)?.com\/docs\/(?:\d+)(?:\/.*)?$/);

export const needsAuth = hasPortalId;

const getGatesMap = gates => gates.reduce((acc, gate) => Object.assign({}, acc, {
  [gate]: true
}), {});

const getScopesMap = user => user.scopes.reduce((acc, scope) => Object.assign({}, acc, {
  [scope]: true
}), {});

export const emptyAuthData = {
  user: {},
  allGates: [],
  gates: {},
  portal: {},
  scopes: {}
};
export const getAuthData = () => {
  const {
    user,
    gates,
    portal
  } = auth.get();
  return {
    user,
    allGates: gates,
    gates: getGatesMap(gates),
    portal,
    scopes: getScopesMap(user)
  };
};